<script lang="ts">
    import ExplicitBadge from '@amp/web-app-components/src/components/Explicit/ExplicitBadge.svelte';
    import { getI18n } from '~/stores/i18n';

    const i18n = getI18n();

    export let chinInlineSticky: boolean = false;
</script>

<span class="explicit-wrapper">
    <ExplicitBadge
        explicitAriaText={$i18n.t('ASE.Web.MusicClassical.Explicit')}
        {chinInlineSticky}
    />
</span>

<style lang="scss">
    .explicit-wrapper :global(svg) {
        width: var(--explicitBadgeSize, 11px);
        height: var(--explicitBadgeSize, 11px);
    }
</style>
